import VideoInputDeviceList from './VideoInputDeviceList';
export default VideoInputDeviceList;